module.exports = __webpack_public_path__ + "static/media/bitterbal_loss.3568ab56.png";